import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

type ContainerProps = {
  $isSetMinContainerHeight?: boolean;
};

export const Container = styled.div<ContainerProps>`
  position: relative;
  z-index: 1;

  ${props =>
    props.$isSetMinContainerHeight &&
    css`
      ${theme.breakpoints.only("mobile")} {
        block-size: 180px;
        margin-block-end: var(--mobile-widget-gap, 16px);
        padding-block: var(--widget-extra-padding, 12px);
      }

      ${theme.breakpoints.only("tablet")} {
        block-size: 270px;
        margin-block-end: var(--mobile-widget-gap, 16px);
        padding-block: var(--widget-extra-padding, 12px);
      }
    `}
`;

export const SlotContent = styled.div`
  line-height: 0;

  > div[id$="__container__"] {
    inline-size: 100%;

    text-align: center;
  }
`;
